import { ConversationRoutes } from './type'

const root = `${ConversationRoutes.root}`
const calls = `${root}/${ConversationRoutes.calls}`
const search = `${root}/${ConversationRoutes.search}`
const searchProfile = `${root}/${ConversationRoutes.search}/${ConversationRoutes.profile}`

export const ConversationsPath = {
  root: root,
  calls: calls,
  search: search,
  searchProfile: searchProfile,
}
